import { render, staticRenderFns } from "./resource-list.vue?vue&type=template&id=1601e99d&"
import script from "./resource-list.vue?vue&type=script&lang=js&"
export * from "./resource-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "resource-list.vue"
export default component.exports